import { Image, Chip } from "@heroui/react";
import { CDN } from "@/lib/cdn";

function getAttributeImg(attr: string) {
  let myAttr = attr.toLowerCase();
  if (attr.includes("/")) {
    // dual attribute

    const attrSplit = attr.split("/");
    myAttr = `${attrSplit[0].toLowerCase()}_${attrSplit[1].toLowerCase()}`;
  }
  return `${CDN}/games/one-piece/images/attributes/${myAttr}.webp`;
}

export default function AttributeStats({
  data,
}: {
  data: Record<string, number>;
}) {
  let display = [];

  const sortedEntries = Object.entries(data).sort(([, a], [, b]) => b - a);

  for (const [k, v] of sortedEntries) {
    // display.push(
    //   <div key={k} className="flex gap-2 mb-2 items-center">
    //     <Image src={getAttributeImg(k)} width={24} height={24} />
    //     {k}: {v}
    //   </div>,
    // );
    display.push(
      <Chip
        className="bg-default-100"
        key={k}
        startContent={
          <Image
            alt={k}
            src={getAttributeImg(k)}
            radius="none"
            width={20}
            height={20}
          />
        }
      >
        {k}: {v}
      </Chip>,
    );
  }

  return (
    <div>
      <div className="mb-2 font-semibold text-lg">Attributes</div>
      <div className="flex flex-wrap gap-2">{display}</div>
      {/* <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
        {JSON.stringify(data, null, 2)}
      </pre> */}
    </div>
  );
}
